@let selectedLocations = this.selectedLocation?.children?.length ?? 0;

<div class="main-container">
  @if (subjectModel) {
    <app-subject-location-image
      [subjectModel]="subjectModel"
      [selectedLocation]="selectedLocation"
      [inspectionTitle]="inspection?.title"
      (locationSelected)="selectGlobalLocation($event)"
    >
    </app-subject-location-image>
  }
  <!-- inspection-menu-content-->
  <ng-container>
    <div #menu class="sticky-header content">
      <!-- Images Filters -->
      <div class="inspection-menu-content">
        <div class="left-content">
          <app-checkbox [checked]="isSelectedImageAll4Select()" *ngIf="inspectionImages.length > 0" (checkedChange)="selectImageAll4Select()">
          </app-checkbox>

          <ng-container *ngIf="(inspectionImages.length > 0 && isImageSelected) || (inspectionReport && isContainLocations())" class="line">
            <div class="vertical-bar"></div>

            <evc-nav-button
              *ngIf="isImageSelected"
              type="tertiary"
              size="sm"
              variant="semi"
              [leftIcon]="trashCanIcon"
              (click)="openMultipleDeleteDialog()"
            >
              {{ "inspectionDataManagement.delete" | translate }}
            </evc-nav-button>

            <evc-nav-button
              *ngIf="canEditInspection() && (isImageSelected || isContainDataplateImageSelected() || isContainUploadingImageSelected())"
              type="tertiary"
              size="sm"
              variant="semi"
              [leftIcon]="penToSquareIcon"
              (click)="openMultipleImageEditDialog()"
            >
              {{ "inspectionDataManagement.edit" | translate }}
            </evc-nav-button>

            @if (isBrianMode) {
              <evc-nav-button
                *ngIf="canEditInspection() && singleImageSelected"
                type="tertiary"
                size="sm"
                variant="semi"
                [leftIcon]="'file-export'"
                (click)="exportCompareImage()"
              >
                {{ "inspectionDataManagement.compareImage" | translate }}
              </evc-nav-button>
            }

            <div
              class="select-all"
              *ngIf="inspectionReport && getNumberOfStillInspectionImage() > 0 && isContainLocations() && canEditInspection() && validateStatus()"
            >
              <evc-nav-button type="tertiary" size="sm" variant="semi" [leftIcon]="fileExportIcon" (click)="selectImageAll4Report($event)">
                {{ "inspectionDataManagement.selectAllForReport" | translate }}
              </evc-nav-button>
            </div>
          </ng-container>

          @if (canManageInspection) {
            <!-- Conditional Section for Selected Location -->
            <div *ngIf="selectedLocation" class="edit-section-summary">
              <div class="vertical-bar" *ngIf="inspectionImages.length > 0"></div>
              <evc-nav-button
                class="link-button"
                type="tertiary"
                variant="square"
                leftIcon="pen-to-square"
                size="sm"
                [disabled]="!selectedLocation"
                (ctaClicked)="openEditSectionCommentDialog()"
              >
                {{ "inspectionDataManagement.editSelection" | translate }}
              </evc-nav-button>
            </div>
          }

          <!-- Marks Filter Form -->
          <div class="marks-filter-form" *ngIf="inspectionImages.length > 0 || hasMarkFilters">
            <div class="marks-filter-inner">
              <app-mark-filter (filterChange)="loadImages()" [filterMarkControl]="filterMarkControl"> </app-mark-filter>
            </div>
          </div>
        </div>

        <div class="right-content">
          <div class="checkbox-container" *ngIf="isBrianMode">
            <input
              class="brian-sync-checkbox"
              type="checkbox"
              [checked]="inspection.id === brianSynchronizedInspectionId"
              id="synchronization-checkbox"
              (change)="updateBrianSynchronizedInspection()"
            />
            <label class="brian-sync-label" for="synchronization-checkbox">
              {{ "inspectionUpsertDialog.brianSynchronization" | translate }}
            </label>
          </div>

          @if (canManageInspection) {
            <evc-nav-button
              id="upload-button"
              type="icon"
              leftIcon="download"
              size="sm"
              [matTooltip]="'inspectionDataManagement.import' | translate"
              (ctaClicked)="openUploadImageDialog()"
            >
            </evc-nav-button>
          }

          <evc-nav-button
            id="information-button"
            type="icon"
            size="sm"
            leftIcon="circle-info"
            [matTooltip]="'inspectionDataManagement.information' | translate"
            (ctaClicked)="openInspectionInfoDialog()"
          >
          </evc-nav-button>

          @if (canManageInspection) {
            <evc-nav-button
              id="export-button"
              type="icon"
              size="sm"
              leftIcon="upload"
              [matTooltip]="'inspectionDataManagement.exportInspection' | translate"
              (ctaClicked)="openExportInspection()"
            >
            </evc-nav-button>
          }
        </div>
      </div>
    </div>
  </ng-container>

  <div class="inspection-images-content content">
    <div fxLayout="column">
      <div *ngIf="selectedLocations > 0" class="parent-location summary-content">
        <div class="inspection-image-location">{{ this.selectedLocation.name }}</div>
        <div class="summary-comment">{{ summaryComment }}</div>
      </div>
      <!--inspection image-->
      <div
        *ngFor="let displayImageList of imagesGroupedByLocation; let locIndex = index"
        fxLayout="column"
        [class.location-group]="displayImageList.images.length > 0"
      >
        <div
          *ngIf="displayImageList.images.length > 0 || imagesGroupedByLocation.length === 1"
          appUploadInspectionFiles
          [locationId]="displayImageList.locationId"
          [inspectionId]="inspection.id"
          [uploadDisabled]="!canEditImage || isImageSelected"
          (drop)="changeOrder(locIndex, displayImageList.locationId)"
          (dragstart)="onDragStart()"
          (dragend)="onDragEnd()"
        >
          <div class="inspection-image-location">{{ displayImageList.displayLocationName }}</div>
          <div *ngIf="this.inspection.id && selectedLocations === 0" class="summary-content">{{ summaryComment }}</div>
          <div fxLayout="row wrap" fxLayoutGap="1rem" class="inspection-cards">
            <div *ngFor="let inspectionImage of displayImageList.images; let imgIndex = index; trackBy: trackByImageItem" class="image-card">
              <div>
                <app-inspection-image-card
                  [draggable]="isSelectedImage4Select(inspectionImage)"
                  (dragover)="onDragOver(imgIndex, $event)"
                  [marks]="marks"
                  [inspectionImage]="inspectionImage"
                  [isSelected]="isSelectedImage4Select(inspectionImage)"
                  [canEditImage]="canEditImage"
                  [selectModeEnabled]="isImageSelected"
                  [isSelectedForReport]="isSelectedImage4Report(inspectionImage)"
                  [havePermissionOnReport]="havePermissionOnReport"
                  [selectForReportModeEnabled]="isShowSelectedIcon(inspectionImage)"
                  (editImage)="openInspectionImageEditDialog($event)"
                  (selectCard)="selectImage4Select($event)"
                  (deleteImage)="deleteSingleImage($event)"
                  (selectImageForReport)="selectImage4Report($event, true)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- placehodler upload card -->
      @if (canManageInspection) {
        <div class="media-card" (click)="openUploadImageDialog()" *ngIf="inspectionImages.length === 0 && !this.selectedLocation">
          <evc-svg-icon class="icon" icon="download"></evc-svg-icon>
          <div class="text">{{ "inspectionDataManagement.importAsUploadPlaceholderCard" | translate }}</div>
        </div>
      }
    </div>
  </div>

</div>
